(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddPaymentInfoController', AddPaymentInfoController);

    AddPaymentInfoController.$inject = ['$http', '$stateParams', '$rootScope', '$state', '$filter', 'dialog', 'cache'];

    function AddPaymentInfoController($http, $stateParams, $rootScope, $state, $filter, dialog, cache) {
        var phone;
        var vm = this;
        vm.$onInit = init;
        vm.save = save;

        vm.close = close;
        vm.onInputChange = onInputChange;
        vm.ibanInfo = ibanInfo;
        vm.submitFiles = submitFiles;
        vm.editInfo = editInfo;

        function onInputChange() {
            vm.saving_loading = false;
            vm.saved = false;
            vm.saving_failed = false;
        }

        function ibanInfo() {
            dialog.info('iban-info');
        }

        function getStripeData() {
            $http.get('api/users/private/get_stripe_data')
                .then(function (response) {
                    vm.stripe_data = response.data;
                    vm.payment_info.first_name = vm.stripe_data.individual.first_name;
                    vm.payment_info.last_name = vm.stripe_data.individual.last_name;
                    vm.payment_info.day_of_birth = vm.stripe_data.individual.dob.day;
                    vm.payment_info.month_of_birth = vm.stripe_data.individual.dob.month;
                    vm.payment_info.year_of_birth = vm.stripe_data.individual.dob.year;
                    vm.payment_info.address = vm.stripe_data.individual.address.line1;
                    vm.payment_info.zip_code = vm.stripe_data.individual.address.postal_code;
                    vm.payment_info.city = vm.stripe_data.individual.address.city;
                    vm.countries.forEach(country => {
                        if (country.country_code == vm.stripe_data.individual.address.country) {
                            vm.payment_info.country = country;
                        }
                    });
                    phone.setNumber(vm.stripe_data.individual.phone);
                });
        }

        function init() {
            vm.payment_info = {};
            vm.uiDateOptions = angular.copy($rootScope.uiDateConfig);
            vm.uiDateOptions.maxDate = new Date();
            $rootScope.header_inverted = false;
            $rootScope.on_dashboard = true;
            vm.mode = $stateParams.mode;

            vm.countries = [
                {
                    'country_name': 'Austria',
                    'country_code': 'AT'
                },
                {
                    'country_name': 'Belgium',
                    'country_code': 'BE'
                },
                {
                    'country_name': 'Denmark',
                    'country_code': 'DK'
                },
                {
                    'country_name': 'Finland',
                    'country_code': 'FI'
                },
                {
                    'country_name': 'France',
                    'country_code': 'FR'
                },
                {
                    'country_name': 'Germany',
                    'country_code': 'DE'
                },
                {
                    'country_name': 'Ireland',
                    'country_code': 'IE'
                },
                {
                    'country_name': 'Italy',
                    'country_code': 'IT'
                },
                {
                    'country_name': 'Luxembourg',
                    'country_code': 'LU'
                },
                {
                    'country_name': 'Netherlands',
                    'country_code': 'NL'
                },
                {
                    'country_name': 'Norway',
                    'country_code': 'NO'
                },
                {
                    'country_name': 'Portugal',
                    'country_code': 'PT'
                },
                {
                    'country_name': 'Spain',
                    'country_code': 'ES'
                },
                {
                    'country_name': 'Sweden',
                    'country_code': 'SE'
                },
                {
                    'country_name': 'Switzerland',
                    'country_code': 'CH'
                },
                {
                    'country_name': 'United Kingdom',
                    'country_code': 'GB'
                },
            ];
            vm.payment_info.country = vm.countries[2];

            if (vm.mode == 'edit') {
                getStripeData();
            }
            if (vm.mode != 'identity_documents_upload') {
                setTimeout(function () {
                    var input = document.querySelector("#phone");
                    phone = window.intlTelInput(input, {
                        utilsScript: "app/assets/js/utils.js",
                        preferredCountries: ["dk", "gb"],
                        defaultCountry: "dk",
                        formatOnDisplay: false,
                        customContainer: "international-phone-input"
                    });
                }, 0);
            }
        }

        function save() {
            vm.saving_loading = true;

            var data = angular.copy(vm.payment_info);
            data.date_of_birth = vm.payment_info.year_of_birth + '-' + vm.payment_info.month_of_birth + '-' + vm.payment_info.day_of_birth
            data.country = vm.payment_info.country.country_code;

            data.iban = data.iban.replace(/\s+/g, '');

            data.phone = phone.getNumber();

            return $http.post('/app/api/users/me/payment_info', data)
                .then(function (response) {
                    vm.saving_loading = false;
                    vm.info_saved = true;
                    cache.clear();
                    $state.go('stripe_connect', { mode: 'identity_documents_upload' });
                })
                .catch(function (response) {
                    vm.save_error = response.data.message.split('\n')[0];
                    vm.saving_loading = false;
                    vm.saving_failed = true;
                });
        }

        function editInfo() {
            vm.saving_loading = true;

            var data = angular.copy(vm.payment_info);
            data.date_of_birth = vm.payment_info.year_of_birth + '-' + vm.payment_info.month_of_birth + '-' + vm.payment_info.day_of_birth
            data.country = vm.payment_info.country.country_code;

            data.iban = data.iban ? data.iban.replace(/\s+/g, '') : "";

            data.phone = phone.getNumber();

            return $http.post('/app/api/users/me/edit_payment_info', data)
                .then(function (response) {
                    vm.finishedEdit = true;
                    vm.saving_loading = false;
                    vm.info_saved = true;
                })
                .catch(function (response) {
                    vm.save_error = response.data.message.split('\n')[0];
                    vm.saving_loading = false;
                    vm.saving_failed = true;
                });
        }

        function submitFiles() {
            if(vm.id_document && vm.additional_document) {
                vm.uploading = true;
                $http.post('/app/api/users/me/stripe_identity_documents', {
                    id_document: vm.id_document_base64,
                    additional_document: vm.additional_document_base64
                })
                .then(function (response) {
                    vm.finished = true;
                    vm.uploading = false;
                })
                .catch(function (response) {
                    vm.uploading = false;
                    vm.save_error = response.data.split('\n')[0];
                    vm.saving_loading = false;
                    vm.saving_failed = true;
                });
            } else {
                vm.save_error = "submit_all_documents";
                vm.saving_loading = false;
                vm.saving_failed = true;
            }

        }

        function close() {
            if ($rootScope.previousState && typeof $rootScope.previousState.name == 'string') {
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                return $state.go('settings');
            }
        }
    }
})();
